import { createContext, useContext, useState } from "react";

export const AntiSpamContext = createContext<{
    antiSpamToken: string | null;
    setAntiSpamToken: React.Dispatch<React.SetStateAction<string | null>>;
}>({
    antiSpamToken: null,
    setAntiSpamToken: () => { },
});

export const useAntiSpam = () => useContext(AntiSpamContext);

export const AntiSpamProvider = ({ children }: { children: React.ReactNode; }) => {
    const [antiSpamToken, setAntiSpamToken] = useState<string | null>(null);

    return (
        <AntiSpamContext.Provider value={{ antiSpamToken, setAntiSpamToken }}>
            {children}
        </AntiSpamContext.Provider>
    );
};